export enum WellKnownFeatureToggleKeys {
    EnableIfKeyMissing = 'featureToggle.enableIfKeyMissing',
    SupportRequestIncludeSessionIds = 'supportRequest.includeSessionIds',
    ToolbarDisplayLogo = 'toolbar.displayLogo',
    LastPriceEnabled = 'lastPrice.enabled',
}

export type FeatureTogglesState = { [feature: string]: boolean | undefined };

export const initialFeatureTogglesState = {
    [WellKnownFeatureToggleKeys.EnableIfKeyMissing]: true,
};
